const TIMESCALE_QUESTION_ID = 1;
const TIMESCALE_QUESTION_ID_ALT = 2;
export default {
  methods: {
    getDescriptionTranslation: function(workType) {
      let companyLanguage = this.company?.communications_language?.iso_code ?? 'en';
      if (companyLanguage === 'en') {
        return workType.description;
      }
      let translation = workType.translations.find(translation => translation.language.iso_code === companyLanguage);
      return (translation !== undefined) ? translation.description : workType.description
    },
    getCategoryTranslation: function(workType) {
      let companyLanguage = this.company?.communications_language?.iso_code ?? 'en';
      if (companyLanguage === 'en') {
        return workType.work_type_category;
      }
      let translation = workType.translations.find(translation => translation.language.iso_code === companyLanguage);
      return (translation !== undefined) ? translation.work_type_category : workType.work_type_category
    },
    getTimescaleTranslation: function(answers) {
      let timescaleAnswer = answers.find(answer => answer.question.id === TIMESCALE_QUESTION_ID);
      if (timescaleAnswer === undefined) {
        timescaleAnswer = answers.find(answer => answer.question.id === TIMESCALE_QUESTION_ID_ALT);
      }
      let companyLanguage = this.company?.communications_language?.iso_code ?? 'en';
      if (companyLanguage === 'en') {
        return timescaleAnswer?.question_option?.option_text;
      }
      let translations = timescaleAnswer?.question_option?.translations ?? [];
      let translation = translations.find(translation => translation.language.iso_code === companyLanguage);
      return (translation === undefined) ? timescaleAnswer?.question_option?.option_text : translation.option_text;
    }
  }
}
